import { OrderDto} from "@hec/api-dtos";

export const GetFaceConfigurationWidthFromOrder = (order: OrderDto): number | null => {
  return order?.faceConfiguration?.width ?? null;
}
